// utils/idObfuscator.ts
const SECRET = 42;

export function encryptProjectId(id: number): string {
  const xored = id ^ SECRET;
  const hex = xored.toString(16); // e.g. 3433 ^ 42 = 3395 → "d43"
  return btoa(hex)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

export function decryptProjectId(token: string): number {
  // Restore base64 padding and url-safe chars
  const base64 = token.replace(/-/g, '+').replace(/_/g, '/');
  const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);

  const hex = atob(padded);             // "d43"
  const xored = parseInt(hex, 16);      // 3395
  return xored ^ SECRET;                // 3433
}